$(function () {
    $(".image-slider-image .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            speed: 800,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            asNavFor: '.image-slider-caption .slider-items',
            instructionsText: 'Changing this current slide of this carousel will change the current slide of the caption carousel that follows.',
            regionLabel: 'image carousel'
        });
    })

    $(".image-slider-caption .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            speed: 800,
            fade: true,
            cssEase: 'ease',
            slidesToShow: 1,
            prevArrow: thisElement.closest('.image-slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.image-slider').find('.sliderNextButton'),
            mobileFirst: true,
            asNavFor: '.image-slider-image .slider-items',
            instructionsText: 'Changing the current slide of this carousel will change the current slide of the preceding image carousel.',
            regionLabel: 'caption carousel'
        });
    })
});